import React, { FC, useEffect } from "react";
import { List } from "../Partials/List";

import { UrlHandler } from "../Utils/UrlHandler";
import { useInsuranceFilters } from "../Utils/Context/filtersContext";
import { useInsuranceLabels } from "../Utils/Context/labelsContext";
import { filterServices } from "../Utils/Filters/filterServices";
import { Keyword } from "../Partials/Keyword";
import { InsuranceServiceDto } from "@apiModels/Insurance/InsuranceServiceDto.csharp";

interface ServicesListProps {
  services: InsuranceServiceDto[];
}

export const ServicesList: FC<ServicesListProps> = (props) => {
  const { services } = props;

  const { specialization, service, locations, setService } =
    useInsuranceFilters();

  const { inputs } = useInsuranceLabels();

  useEffect(() => {
    const foundService = UrlHandler.getEntryFromUrlQuery<InsuranceServiceDto>(
      services,
      "serviceId"
    );
    foundService && setService(foundService as InsuranceServiceDto);
  }, []);

  const filteredServices = filterServices(
    {
      specialization,
      locations,
    },
    services
  );

  const serviceClick = (selectedService: InsuranceServiceDto) => {
    selectedService.id === service?.id
      ? setService(null)
      : setService(selectedService);
  };

  const renderItem = (item: InsuranceServiceDto, key: number) => {
    return (
      <li key={`${item.id}-${key}`}>
        <Keyword
          isSelected={service?.id === item.id}
          onClick={() => serviceClick(item)}
          label={item.bookingName}
        />
      </li>
    );
  };

  if (!specialization) return <></>;
  return (
    <List<InsuranceServiceDto>
      heading={
        <h2 className="servicesList__heading">{inputs.servicesLabel}</h2>
      }
      items={filteredServices}
      renderItem={renderItem}
      className="servicesList"
      listClassName="servicesList__items"
      itemsClamp={8}
    />
  );
};
